import { useState } from 'react';

export default () => {
  const [locale, setLocale] = useState('zh-CN');
  
  return {
    locale,
    setLocale,
  };
};
